<template lang='pug'>
v-dialog(scrollable max-width='460px' v-model='value' persistent lazy)
  v-card
    v-card-title(class='title')
      section
        div(class='title') Записаться на осмотр
        div(class='subheading mt-2')
          | в {{ complex.complex_name }}
          | на {{ eventModel.start | date('DD MMM YYYY в HH:mm') }}
    v-card-text
      v-form(ref='form')
        v-container(grid-list-lg fluid class='pa-0')
          v-layout(row wrap)
            v-flex(xs12)
            v-flex(xs12)
              v-select(
                :items='deals'
                :return-object='true'
                :item-text='i => `${i.num}: ${i.object_name}, №${i.number}`'
                :rules='[v => v &&!!Object.keys(v).length || "Выберите договор"]'
                item-value='id'
                label='Выберите договор'
                v-model='eventModel.deal'
              )
    v-card-actions
      v-spacer
      v-btn(@click='$emit("input", false)' flat) Отмена
      v-btn(@click='emitChange' :loading='isLoading' flat color='primary') Ok
</template>

<script>
import { mapState, mapActions } from 'vuex'

const eventModel = {
  deal: {}
}

export default {
  props: ['value', 'event', 'isLoading', 'complex', 'client'],

  data: () => ({
    eventModel: { ...eventModel }
  }),

  methods: {
    emitChange() {
      if (this.$refs.form.validate()) {
        let { deal, id } = this.eventModel
        this.$emit('change', {
          schedule_id: id,
          deal_id: deal.id,
          client_id: this.client.id
        })
      }
    },

    ...mapActions('client/schedule', ['fetchDeals'])
  },

  watch: {
    event(value) {
      if (Object.keys(value).length) {
        this.eventModel = Object.assign({}, value, eventModel)
      } else {
        this.eventModel = { ...eventModel }
      }
    },
    /**
     * Будем следить за состоянием видимости модального окна
     * и сбрасывать модель и валидацию, если окно закрыто,
     * в противном случае получать список договоров
     * @param {boolean} visible
     */
    value(visible) {
      if (visible) {
        this.fetchDeals(this.eventModel.id)
      } else {
        this.$refs.form.reset()
        this.eventModel = { ...eventModel }
      }
    }
  },

  computed: mapState('client/schedule', ['deals'])
}
</script>
